import { ApiVersion } from "../const";

export const getAllLogs =(token: string, iniDate: string, finDate: string)=>{
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ iniDate, finDate })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}/getAllLogs`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}